import { memo, useContext } from "react";
import TinkoffImageUrl from "./assets/tinkoff.png";
// import UsdtImageUrl from "./assets/usdt.png";
import UsdcImageUrl from "./assets/usdc.png";
import Image from "next/image";
import { numberWithSpaces } from "../../../utils/number-with-spaces.utils";
import { useRouter } from "next/router";
import { SiteConfig } from "../../../pages/bootcamp/[slug]";
import { LottieChicken } from "./assets/animated-chicken";
import { getCourseStatus } from "../../../utils/course-utils";

interface Props {
  priceRub: number;
  oldPriceUsdt: number;
  appliedDiscount?: number;
  descriptionForPrice: string;
  orTitle: string;
  isLoading: boolean;
  id: string;
}

export const PriceList = memo<Props>(
  ({
    priceRub,
    oldPriceUsdt,
    appliedDiscount,
    descriptionForPrice,
    orTitle,
    isLoading,
    id,
  }) => {
    const { locale } = useRouter();
    const currentDiscountFromCMS = useContext(SiteConfig);

    const MONTH_OF_TINKOFF_CREDIT = 24;

    const usdtPriceToShow = numberWithSpaces(
      Math.floor(oldPriceUsdt * (1 - currentDiscountFromCMS / 100))
    );

    const priceUsdtWithPromocodeToShow = appliedDiscount
      ? numberWithSpaces(
        Math.floor(
          Number(
            oldPriceUsdt *
                (1 - currentDiscountFromCMS / 100) *
                (1 - appliedDiscount / 100)
          )
        )
      )
      : usdtPriceToShow;

    const oldPriceRubToShow = numberWithSpaces(
      Math.floor((priceRub * oldPriceUsdt) / MONTH_OF_TINKOFF_CREDIT)
    );

    const priceRubNew =
      (priceRub *
        Math.floor(oldPriceUsdt * (1 - currentDiscountFromCMS / 100))) /
      MONTH_OF_TINKOFF_CREDIT;

    const priceRubWithPromocode = appliedDiscount
      ? numberWithSpaces(
        Math.floor(Number(priceRubNew * (1 - appliedDiscount / 100)))
      )
      : numberWithSpaces(Math.floor(Number(priceRubNew)));

    const { isPaidCourses, isFreeCourses } = getCourseStatus(id);

    return (
      <div className="lg:bg-day-base-base-100 bg-white/30 rounded-[20px] w-[inherit] lg:min-w-[400px] relative">
        {isPaidCourses && (
          <div className="absolute top-6 right-5 md:right-7 bg-blue text-[16px] leading-[160%] text-white py-2 px-6 rounded-[30px]">
            -{currentDiscountFromCMS}%
          </div>
        )}

        {isFreeCourses && (
          <div className="absolute top-6 right-5 md:right-7 bg-blue text-[16px] leading-[160%] text-white py-2 px-6 rounded-[30px]">
            FREE
          </div>
        )}
        {locale === "ru" && (
          <div className="pt-35 border-b border-dashed border-day-base-base-200">
            <div className="relative max-w-max lg:max-w-full">
              <div className="flex w-full pl-10 md:pl-0 md:block">
                <div className="w-[60px] h-[60px]">
                  <Image
                    className="h-w-max w-[63px] md:relative left-[32px]"
                    src={TinkoffImageUrl}
                    alt="Tinkoff logo"
                  />
                </div>
                {isLoading ? (
                  <div className="h-[103px] bg-transparent overflow-hidden w-full">
                    <div className="h-[103px] animation-slide">
                      <LottieChicken />
                    </div>
                  </div>
                ) : (
                  <div className="pl-10 md:pl-[32px] md:pt-12">
                    <div className="line-through text-[18px] md:text-[20px] leading-[124%] text-day-base-base-400">
                      {oldPriceRubToShow} ₽/мес
                    </div>
                    <div className="pt-2 md:pt-5 text-[32px] leading-[112%] md:text-[44px] md:leading-[100%] text-day-base-base-900">
                      {priceRubWithPromocode} ₽/мес
                    </div>
                  </div>
                )}
              </div>
              <div className="pt-8 pl-10 md:pl-[32px] pb-10 text-[16px] leading-[120%] text-day-base-base-400 leading-tight text-day-base-base-400 max-w-[255px]">
                В рассрочку на 24 месяца.
                <br />
                Без процентов и переплат.
              </div>
            </div>
            <div className="flex justify-center">
              <span className="bg-white lg:bg-day-base-base-100 text-day-base-base-400 text-[14px] leading-[20px] uppercase relative bottom-[-10px] pl-3 pr-3">
                {orTitle.toLocaleLowerCase()}
              </span>
            </div>
          </div>
        )}

        <div
          className={`pb-20 ${
            locale === "en" ? "h-full pt-40 lg:pt-20" : "pt-20"
          }`}
        >
          <div
            className={`relative max-w-max lg:max-w-full ${
              locale === "en" ? "flex justify-center items-center h-full" : ""
            }`}
          >
            <div className="flex items-center w-full pl-10 md:pl-16 md:block">
              <div
                className={`w-[60px] h-[60px] ${
                  locale === "en" ? "lg:m-auto" : ""
                }`}
              >
                <Image
                  className="w-full h-auto"
                  src={UsdcImageUrl}
                  alt="USDC logo"
                />
              </div>
              {isLoading ? (
                <div className="h-[103px] bg-transparent overflow-hidden w-full">
                  <div className="h-[103px] animation-slide">
                    <LottieChicken />
                  </div>
                </div>
              ) : (
                <div
                  className={`pl-10 md:pl-0 md:pt-12 ${
                    locale === "en" ? "lg:text-center" : ""
                  }`}
                >
                  {isPaidCourses && (
                    <div className="line-through text-[18px] md:text-[20px] leading-[124%] text-day-base-base-400">
                      {oldPriceUsdt} USDC
                    </div>
                  )}
                  {isPaidCourses && (
                    <div className="pt-2 md:pt-5 text-[32px] leading-[112%] md:text-[44px] md:leading-[100%] text-day-base-base-900">
                      {priceUsdtWithPromocodeToShow} USDC
                    </div>
                  )}
                  {isFreeCourses && (
                    <div className="pt-2 text-[32px] leading-[112%] md:text-[36px] text-day-base-base-900">
                      0 USDC
                    </div>
                  )}
                </div>
              )}
            </div>
            <div // eslint-disable-next-line
              dangerouslySetInnerHTML={{
                __html: descriptionForPrice,
              }}
              className="pt-8 pl-10 md:pl-16 pb-10 text-[16px] leading-[120%] text-day-base-base-400 leading-tight text-day-base-base-400 max-w-[290px]"
            ></div>
          </div>
        </div>
      </div>
    );
  }
);
